/* eslint-disable */
export default {
  _click: 'click',
}